<template>
  <div>
    <NavBar :breadcrumbdata="breadcrumbsinfo" breadcrumbtheme="breadcrumbcss" />
    <section  class="navbarsection">
      <main>
        <div class="videosection">
            <Transition class="transition thing">
              <video-background 
                playbackRate=0.2
                :src="src"
                :poster="poster"
        
                overlay="linear-gradient(to bottom, #003, transparent)" 
                :class="`thing playercss`"
                :style="`height: 556px;`" v-show="pvisvideo === true">
              </video-background>
            </Transition>
            <div id="panorama" class="thing  gradient" v-show="pvisvideo === false">
            </div>
        </div>
        
        <div class="txtdata">
          <h1 class="rainbow-text" v-html="imagetext" :class="formatvhtml"></h1>
        </div>
      </main>
   
    </section>

  <div class="seven3css">
    <SeventyThirtysection :LeftsideText="transsec1text" :RightsideText="transsec2text" leftsectheme="leftseccss" />
  </div>

  <div class="youtubecss">
    <YoutubeVideoplayer :youtubevideopath="youtubevideopath" :coverpage="coverpage" 
    :topmessage="topmessage" youtubeplayertheme="youtubeplayercss" />
  </div>

  <section>
    <div>
      <AllonlyNews :allnewsdata="newsdata" @click="goToNextPage($event); goToPreviousPage($event);" 
        :showNextButton="showNextButton" :showPreviousButton="showPreviousButton" 
        />
    </div>
  </section>

    <FooterPage />
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue';
import FooterPage from '@/components/FooterPage.vue';
import SeventyThirtysection from '@/components/SeventyThirtysection.vue';
import YoutubeVideoplayer from '@/components/YoutubeVideoplayer.vue';
import AllReports from '@/components/AllReports.vue';
import AllonlyNews from '@/components/AllonlyNews.vue';
require('@/assets/css/pannellium-2.5.css');
require('@/assets/css/video-js.css');
require('@/globalDeclare.js');
import axios from 'axios';
import { faAnglesLeft } from '@fortawesome/free-solid-svg-icons';


export default {
  name: 'AboutView',
  components: {
  NavBar, FooterPage, SeventyThirtysection, AllReports, YoutubeVideoplayer, AllonlyNews
},
data() {
  return {
  videoimage: [],
  imagetext: '',
  src: '',
  playrate: '',
  poster: '',
  pvwebm: '',
  pvmp4: '',
  pvstyle: '',
  pvsrc: '',
  pvisvideo: false,
  pvpanorama1: '',
  pvpanorama2: '',
  pvpanorama3: '',
  pvhotspot1: '',
  pvhotspot2: '',
  pvhotspot3: '',
  showVideo: false,
  showPanorama: false,

  youtubevideopath: '',
  coverpage: '',
  topmessage: '',

  newsdata: [],
  showNextButton: false,
  showPreviousButton: false,
  currentPage: 1,
  query: '',


  myPicUrl: '',

  // corpgovernpolicy: [],
  transsec1text: '',
  transhighlight: '',
  transsec2text: '',
  }
},
methods: {
  async goToNextPage($event) {
  let eAction = $event.target.value
  if (eAction === 'moveNext') {
    this.currentPage +=1,
    this.getNewsdata()
  }
 },
 async goToPreviousPage($event) {
  let pAction = $event.target.value
  if (pAction === 'movePrevious') {
    this.currentPage -=1,
    this.getNewsdata()
  }
 },

 async submitForm(event, inputVal) {
  if (event === 'submitform') {
    console.log('Form submitted')
    console.log(inputVal)
  }
 },

 async getNewsdata() {
  this.$store.commit('SetIsLoading', true)

  this.showNextButton = false
  this.showPreviousButton = false
  //-----------Homepage News section-------------
  await axios.get(`homepagenewslisting/?page=${this.currentPage}`).then(
      response => {
        console.log(response.data)
          this.newsdata = response.data.results
          if(response.data.next) {
            this.showNextButton = true
          }
          if(response.data.previous) {
            this.showPreviousButton = true
          }
    })
    .catch((error) => {
        console.log(error)
      })

 }
},
async mounted() {
  this.myPicUrl = myUrlPath

  this.getNewsdata()

await axios.get('allpagespv/transaction').then(
    response => {
      this.videoimage = response.data
      
      this.imagetext = this.videoimage.pvdisplaytext 
      this.src = this.videoimage.pvsrc
      this.playrate = this.videoimage.playbackrate
      this.poster = this.videoimage.pvposter
      // this.pvsrc = this.videoimage.pvsrc
      // this.pvmp4 = this.videoimage.pvmp4
      this.pvstyle = this.videoimage.pvstyle
      this.pvisvideo = this.videoimage.pvisvideo
      this.pvpanorama1 = this.videoimage.pvpanorama1
      this.pvpanorama2 = this.videoimage.pvpanorama2
      this.pvpanorama3 = this.videoimage.pvpanorama3
      this.pvhotspot1 = this.videoimage.pvhotspot1
      this.pvhotspot2 = this.videoimage.pvhotspot2
      this.pvhotspot3 = this.videoimage.pvhotspot3

      // let pvisvideo1 = this.videoimage.pvisvideo
      // this.pvisvideo = pvisvideo1


      if (this.pvisvideo === 'true') {
        this.src = this.videoimage.pvmp4
        this.showVideo
        if (response.status === 403 ) {
        e = "No data available"
        const toast = useToast();
        toast.success(e, {
        timeout: 6000
        });
        }
        else if (response.status === 404) {
          e = "Page Not Found!"
          const toast = useToast();
          toast.success(e, {
          timeout: 6000
        });
        }
      }
      else{
          const config = {
          autoLoad: true,
          scenchange: true,
          compass: false,
          northOffset: -237.5,
          default: {
              firstScene: "hotspotoffice",
              sceneFadeDuration: 1000,
              autoRotate: -.6,
              setTimeout: 100,
              preview: this.poster
              
          },
          scenes: {
              hotspotoffice: {
                  hfov: 180,
                  pitch: 0,
                  yaw: 0,
                  type: "equirectangular",
                  panorama: this.pvpanorama1,
                  hotSpots: [
                      {
                          pitch: 4,
                          yaw: 21.8,
                          type: "scene",
                          sceneId: "anotherhotspot",
                          text: this.pvhotspot1,
                      }
                  ]
              },
              anotherhotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama2,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "lasthotspot",
                            text: this.pvhotspot2,
                        }
                    ]
                },
                lasthotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama3,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "hotspotoffice",
                            text: this.pvhotspot3,
                        }
                    ]
                },
              
            }
        };
        pannellum.viewer('panorama', config);
      }
      console.log(this.src)
  })
  .catch((error) => {
      console.log(error)
    }) 
  
    //-----------All invest page report data--------------
    axios.get('getinvestinfo/').then(
    response => {
        this.investpagereport = response.data
        this.transsec1text = response.data[0].invquestsec1
        this.transsec2text = response.data[0].invquestsec2
    })
    .catch((error) => {
      console.log(error)
    }) 
  
  //------------all highlights---------------
  await axios.get('getallhiglights/transaction').then(
    response => {
        this.transhighlight = response.data[0].highlightdesc
  })
  .catch((error) => {
      console.log(error)
    })

    
  //------------All Youtube videos---------------
  await axios.get('getyoutubevideo/transaction').then(
      response => {
      this.youtubevideopath = this.myPicUrl + response.data[0].uploadyv
      this.coverpage = this.myPicUrl + response.data[0].coverpage
      this.topmessage = response.data[0].yvdesc
      
  })
  .catch((error) => {
      console.log(error)
      })

  
}
}
</script>

<style scoped>
.txtdata {
  text-align: left;
  background-color: #003;;
  margin-left: 0px;
  opacity: 0.7;
  margin-top: -100px;
 }
.section03 {
  height: 300px;
}
.container {
  display: grid;
  height: 100vh;;
  grid-template-columns: 1fr;
  grid-template-rows: .2fr 1.2fr .2fr;
  grid-template-areas: 
  "nav nav nav" 
  "main main main" 
  "footer footer footer";
  grid-gap: 0.2rem;
  font-family: "Inter", sans-serif;
  font-size: 800;
  font-size: 12px;
  color: #234234;
  text-align: center;
}

html { 
  height: 100%;
  margin:0px;
  background: url('../assets/slide-5.jpg') no-repeat center center;
  background-size: cover;
  background-attachment: fixed;
}

main {
  background: white;
  grid-area: main;
  padding-left: 0px;
  padding-right: 0px;
  margin-left: 0px;
  margin-right: 0px;
  border-radius: 0px;
  margin-top:-5px;
}
.formatrow {
  margin-top: 340px;
  padding-left: 100px;
  padding-right: 100px;
}
.leftseccss {
  margin-top: 100px;
}

.reportpresentcss {
  margin-top: 300px;
}
.imagecss {
  width: 80%;
  padding-left: 50px;
  padding-bottom: 100px;
}
.seven3css {
  margin-top: 120px;
}
.youtubeplayercss {
  background-color: #003;
  color: white;
}
/* Move the background and make it larger. 
/* Media Query CSS*/
/* Move the background and make it larger. 
/* Media Query CSS*/
@media only screen and (max-width: 600px) {
  .imagecss {
      width: 90%;
      margin: 0 auto;
      padding-bottom: 100px;
    }
    .txtdata {
      margin-bottom: 100px;
      width: 400px;
      padding-right: 10px;
    }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .imagecss {
      width: 90%;
      margin: 0 auto;
      padding-bottom: 100px;
    }
    .txtdata {
      margin-bottom: 200px;
      width: 600px;
      padding-right: 10px;
    }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .imagecss {
      width: 90%;
      margin: 0 auto;
      padding-bottom: 100px;
    }
    .txtdata {
      margin-bottom: 30px;
      width: 700px;
      padding-right: 10px;
    }
}


/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .txtdata {
    margin-bottom: 100px;
    width: 800px;
    padding-right: 10px;
  }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {

}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1400px) {

}

 /* Extra large devices (large laptops and desktops, 1200px and up) */
 @media only screen and (min-width: 1600px) {

}
</style>
